/**
 * Environment configuration
 * 
 * Configure API URLs based on environment
 */

const ENV = {
  // Development environment
  development: {
    API_BASE_URL: import.meta.env.VITE_API_URL_STAGING,
    API_KEY: import.meta.env.VITE_API_KEY_STAGING || '',
    REPORTING_URL: 'https://dev.rewardsinsights.aagroup.cloud',
  },
  // Production environment
  production: {
    API_BASE_URL: import.meta.env.VITE_API_URL_PRODUCTION,
    API_KEY: import.meta.env.VITE_API_KEY_PRODUCTION || '',
    REPORTING_URL: 'https://rewardsinsights.aagroup.cloud',
  },
  // Staging environment
  staging: {
    API_BASE_URL: import.meta.env.VITE_API_URL_STAGING,
    API_KEY: import.meta.env.VITE_API_KEY_STAGING || '',
    REPORTING_URL: 'https://dev.rewardsinsights.aagroup.cloud',
  },
}

// Determine current environment
const currentEnv = import.meta.env.MODE || 'development'

// Export configuration for current environment
export const config = ENV[currentEnv] || ENV.development

export default config
